export default function Marquee() {
  const words = [
    "COMPASSION WITHOUT LIMITS",
    "RESCUE",
    "REHABILITATE",
    "REPEAT",
    "SINCE GENERATIONS",
    "EVERY LIFE MATTERS",
  ];
  const line = [...words, ...words];
  return (
    <div
      data-testid="marquee-ribbon"
      className="bg-[#1B4D3E] text-[#FDFBF7] py-5 border-y border-[#D4AF37]/30 overflow-hidden"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {line.concat(line).map((w, i) => (
          <span
            key={i}
            className="font-display italic text-3xl md:text-4xl lg:text-5xl px-8 flex items-center"
          >
            {w}
            <span className="ml-8 text-[#D4AF37]">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
